import orders from './list/reducers'
import searchAddressWithNo from './searchAddressWithNo/reducers'
import create from './create/reducers'

export default {
  orders,
  searchAddressWithNo,
  create,
}
